import React from "react";

const BankInfoCard = ({
  classes,
  tax_number,
  payroll_method,
  bank_account_number,
  bank_swiftcode,
  bank_name,
  setBankName,
  setPayrollMethod,
  setInsuranceNumber,
  setBankAccountNumber,
  setTaxNumber,
  setBankSwiftCode,
  insurance_number
}) => {
    const methods =["cash","bank"]
  const handleInsuranceNumber = (e) => {
    const { value } = e.target;
    setInsuranceNumber(value);
  };
  const handleTaxNumber = (e) => {
    const { value } = e.target;
    setTaxNumber(value);
  };
  const handlePayrollMethodChange = (e) => {
    const { value } = e.target;
    setPayrollMethod(value);
  };
  const handleBank = (e) => {
    const { value } = e.target;
    const { name } = e.target;
    if (name === "bank_name") {
      setBankName(value);
    }
    if (name === "bank_swiftcode") {
      setBankSwiftCode(value);
    }
    if (name === "bank_account") {
      setBankAccountNumber(value);
    }
  };

  return (
    <div className="card">
      <div className="card-body">
        <div className={classes.formGrid}>
          <div className={classes.formCol}>
            <label htmlFor=""> رقم التأمين</label>
            <div className={classes.iconInput}></div>
            <input
              type="text"
              placeholder="  ادخل   رقم التأمين"
           value={insurance_number}
              onChange={handleInsuranceNumber}
              className={classes.inputCustom}
            />
          </div>
          <div className={classes.formCol}>
            <label htmlFor=""> الرقم الضريبي</label>
            <div className={classes.iconInput}></div>
            <input
              type="text"
              placeholder="  ادخل   الرقم الضريبي"
              value={tax_number}
              onChange={handleTaxNumber}
              className={classes.inputCustom}
            />
          </div>
          <div className={classes.formCol}>
            <label htmlFor="">طريقة كشوف المرتبات</label>
            <div className={classes.iconInput}></div>
            <select
              type="text"
              placeholder="  طريقة كشوف المرتبات   "
              onChange={handlePayrollMethodChange}
              className={classes.inputCustom}>
                   {methods.map((method ,i)=>(
                <option key={i} value={method}>{method}</option>
             )) }
        
            </select>
          </div>
         {payroll_method==="bank"&&
         
         <>
               <div className={classes.formCol}>
            <label htmlFor="">اسم البنك </label>
            <div className={classes.iconInput}></div>
            <input
              type="text"
              name="bank_name"
              value={bank_name}
              placeholder="اسم البنك "
              onChange={handleBank}
              className={classes.inputCustom}
            />
          </div>
          <div className={classes.formCol}>
            <label htmlFor="">swiftcode-رمز البنك السريع</label>
            <div className={classes.iconInput}></div>
            <input
              type="text"
              value={bank_swiftcode}
              name="bank_swiftcode"
              placeholder="
رمز البنك السريع"
              onChange={handleBank}
              className={classes.inputCustom}
            />
          </div>
          <div className={classes.formCol}>
            <label htmlFor=""> رقم حساب البنك</label>
            <div className={classes.iconInput}></div>
            <input
              type="text"
              name="bank_account"
              value={bank_account_number}
              placeholder="
رقم حساب البنكي   "
              onChange={handleBank}
              className={classes.inputCustom}
            />
          </div>
         </>
   
          }
        </div>
      </div>
    </div>
  );
};

export default BankInfoCard;
